import { IFootTrafficFilterQuery, IFootTrafficReportPayload } from '@/Interfaces/Attribution/FootTraffic.interface';
import type {
  IFootTrafficWeekInsightRequest,
  IFootTrafficWeekInsightResponse,
} from '@/Interfaces/Attribution/FootTrafficWeekInsight.interface';
import { IOfflineSalesDataReport } from '@/Interfaces/Attribution/Report.interface';
import { OfflineSalesFilters } from '@/types/Attribution/filters.types';
import axios from 'axios';

export const fetchOfflineSales = async (params: OfflineSalesFilters): Promise<IOfflineSalesDataReport> => {
  const res = await axios.get('/attribution/offlineSalesReport', { params });
  return res.data;
};

export const downloadOfflineSalesConversions = async (
  params: OfflineSalesFilters,
): Promise<{ blob: Blob; filename: string | null }> => {
  const res = await axios.get<Blob>('/attribution/offlineSalesConversions/export', {
    params,
    responseType: 'blob',
  });

  const disposition = res.headers['content-disposition'] as string | undefined;
  const filename = disposition?.match(/filename="?([^";]+)"?/)?.[1] ?? null;

  return { blob: res.data, filename };
};

export const fetchFootTrafficReports = async <T>(payload: IFootTrafficReportPayload): Promise<T> => {
  const response = await axios.post<T>('/attribution/foot-traffic', payload);
  return response.data;
};

export const fetchFootTrafficFilterOptions = async <T>(params: IFootTrafficFilterQuery): Promise<T> => {
  const response = await axios.post<T>('/attribution/foot-traffic/filter-options', params);
  return response.data;
};

export const fetchFootTrafficVenueCoverage = async <T>(params: {
  advertiserIds?: number[];
}): Promise<T> => {
  const response = await axios.post<T>('/attribution/foot-traffic/venue-coverage', params);
  return response.data;
};

export const fetchFootTrafficWeekInsight = async (
  payload: IFootTrafficWeekInsightRequest,
): Promise<IFootTrafficWeekInsightResponse> => {
  const response = await axios.post<IFootTrafficWeekInsightResponse>('/attribution/foot-traffic/week-insight', payload);
  return response.data;
};
